module.exports = __webpack_public_path__ + "img/features-tileset-studio-brushes.5e1c8561.png";